import PropTypes from 'prop-types';

import IconComponent from 'Component/Icon';

/** @namespace Bodypwa/Component/UpdateIcon/Component */
export class UpdateIconComponent extends IconComponent {
    static propTypes = {
        size: PropTypes.string.isRequired,
        color: PropTypes.string.isRequired
    };

    render() {
        const { dimensions, colors } = this;
        const { size, color } = this.props;
        return (
            <svg
              width={ dimensions[ size ] }
              height={ dimensions[ size ] }
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
            <path
              d="M10.75 5.75C14.2018 5.75 17 8.54822 17 12H14L18 17L22 12H19.5C19.5 7.16751
            15.5825 3.25 10.75 3.25C5.91751 3.25 2 7.16751 2 12C2 16.8325 5.91751 20.75 10.75
            20.75C12.9056 20.75 14.8792 19.9705 16.4042 18.678L14.8416 16.7247C13.7452 17.675
            12.3148 18.25 10.75 18.25C7.29822 18.25 4.5 15.4518 4.5 12C4.5 8.54822 7.29822 5.75
            10.75 5.75Z"
              fill={ colors[ color ] }
              className="icon-color"
            />
            </svg>

        );
    }
}
export default UpdateIconComponent;
